import { Seo } from "@/components/seo/Seo";
import { ConnectStravaButton } from "@/components/strava/ConnectStravaButton";
import { FullScreenLoading } from "@/components/ui/loading";
import { userAtom } from "@/state/auth.state";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai";
import { Navigate, Outlet } from "react-router-dom";

export default function AuthedLayout() {
  const user = useAtomValue(userAtom);
  const stravaId = user?.user_metadata.strava_athlete_id;

  if (user === undefined) {
    return (
      <FullScreenLoading
        title={<Trans>Loading your account…</Trans>}
        description={<Trans>Fetching your session and preferences.</Trans>}
      />
    );
  }

  if (user === null) {
    return <Navigate to="/home" replace />;
  }

  if (!stravaId) {
    return (
      <div className="min-h-dvh w-full flex items-center justify-center p-6">
        <ConnectStravaButton />
      </div>
    );
  }

  return (
    <>
      <Seo title={t`Dashboard`} noindex />
      <Outlet />
    </>
  );
}
